var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autocomplete',{ref:"new_autocomplete",staticStyle:{"width":"100%","height":"51px","border":"1px solid #dbdbdb"},attrs:{"options":{fields: ['geometry'], componentRestrictions: {country: 'it'}}},on:{"place_changed":_vm.set_place},nativeOn:{"input":function($event){return _vm.set_text.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }